// extracted by mini-css-extract-plugin
module.exports = {"layout":"Events_layout__2p-uK"};